// import app from "gridsome/lib/app";
import { Commons } from '../../utils/commons'
import { AppData } from './appData'

class Formatter {
  static parseExternalAppInfo(raw) {
    if (!raw) return null
    const appData = new AppData()
    appData.setContent('appInfo').setMetaData({
      ...raw,
      sizes: raw.sizes,
    })
    return appData
  }

  static parseExternalSubscription(raw, isPlatformAccessSubscription) {
    if (!raw) return null
    const appData = new AppData()
    const isActive = raw.status == '' || raw.status == 'active'
    appData
      .setContent(
        isPlatformAccessSubscription
          ? 'platformAccessSubscription'
          : 'subscription',
      )
      .setMetaData({
        ...raw,
        isActive: isActive,
        status: raw.status || isActive ? 'active' : 'inactif',
        subscriberId: raw.subscriberId,
        endDate: raw.endDate || 0,
        startDate: raw.startDate || 0,
      })
    return appData
  }

  static parseExternalWalletInfo(raw) {
    console.log(raw)
    if (!raw) return null
    const appData = new AppData()
    appData.setContent('walletInfo').setMetaData({
      balance: raw?.availableBalance?.body?.data?.balance || '0',
      pendingBalance: raw?.pendingBalance?.body?.data?.balance || '0',
    })
    return appData
  }

  static parseDomainDataResponse(raw) {
    console.log(raw)
    if (!raw) return {}
    const domainNameInstalled = raw.checkDomain?.body?.statusCode == 200
    const configuredZone = (raw.resolveDns?.body?.Answer || [])[0]?.data
    const dnsZoneCorrectlyConfigured = configuredZone == 'apis.ecoxurf.com.'
    const detectedHostingProvider = detectHostingProvider(configuredZone || '')
    return {
      domainNameInstalled,
      configuredZone,
      dnsZoneCorrectlyConfigured,
      detectedHostingProvider,
    }
  }

  static parseExternalStore(raw) {
    if (!raw) return null
    const appData = new AppData()
    appData.setContent('storeData').setMetaData({
      ...raw,
      id: raw.id,
      cardPaymentEnabled: raw.cardPaymentEnabled,
      customDomainName: raw.customDomainName,
      deliveryMethod: raw.deliveryMethod,
      facebookLink: raw.facebookLink,
      instagramLink: raw.instagramLink,
      linkedinLink: raw.linkedinLink,
      logo: raw.logo,
      currency: raw.currency,
      mainColor: raw.mainColor,
      mobileMoneyPaymentEnabled: raw.mobileMoneyPaymentEnabled,
      notifyCustomerOnOrderDelivered: raw.notifyCustomerOnOrderDelivered,
      notifyCustomerOnPaymentDone: raw.notifyCustomerOnPaymentDone,
      notifyStoreOnBalanceUpdated: raw.notifyStoreOnBalanceUpdated,
      notifyStoreOnOrderDelivered: raw.notifyStoreOnOrderDelivered,
      notifyStoreOnPaymentDone: raw.notifyStoreOnPaymentDone,
      publicStoreId: raw.publicStoreId,
      snapchatLink: raw.snapchatLink,
      storeName: raw.storeName,
      twitterLink: raw.twitterLink,
      useCustomDomain: raw.useCustomDomain,
      userId: raw.userId,
      whatsappChannel: raw.whatsappChannel,
      whatsappNumberHelp: raw.whatsappNumberHelp,
    })
    return appData
  }

  static parseExternalCategories(rawCategories) {
    if (!rawCategories) return null
    if (!Array.isArray(rawCategories)) return null
    const appData = new AppData()
    appData.setContent('categories').setMetaData({
      categories: rawCategories.map(category => {
        return {
          ...category,
          id: category.id,
          name: category.name,
          image: category.image,
        }
      }),
    })
    return appData
  }

  static parseExternalProducts(rawProducts) {
    if (!rawProducts) return null
    if (!Array.isArray(rawProducts)) return null
    const appData = new AppData()
    appData.setContent('products').setMetaData({
      products: rawProducts
        .map(Formatter.parseExternalProductDetails)
        .reverse(),
    })
    return appData
  }

  static parseExternalDeals(products, rawDeals) {
    if (!rawDeals) return null
    if (!Array.isArray(rawDeals)) return null
    const appData = new AppData()
    appData.setContent('deals').setMetaData({
      deals: rawDeals
        .map(deal => {
          const product = products.find(product => product.id == deal.productId)
          if (!product) return null
          return {
            ...Formatter.parseExternalProductDetails(product),
            ...deal,
            id: deal.id,
            discount: deal.discount || 0,
            discountedPrice:
              product.price - (product.price * deal.discount) / 100,
            endDate: deal.endDate,
            inPercent: deal.inPercent,
            isActive: deal.isActive,
            productData: product,
            productId: deal.productId,
            startDate: deal.startDate,
            storeId: deal.storeId,
          }
        })
        .filter(deal => !!deal)
        .sort((o1, o2) => o2.startDate - o1.startDate),
    })
    return appData
  }

  static parseExternalProductDetails(product) {
    return {
      // ...product,
      id: product.id,
      name: product.title,
      price: product.price,
      currency: product.currency,
      storeId: product.storeId,
      storeName: product.storeName,
      description: product.description,
      category: product.category,
      categoryId: product.categoryId,
      subcategory: product.subcategory,
      subcategoryId: product.subcategoryId,
      image: product.principalImageUrl,
      brand: product.brand,
      color: product.color,
      material: product.material,
      condition: product.condition,
      weight: product.weight,
      size: product.size,
      weightUnit: product.weightUnit,
      quantity: product.quantity,
      images: product.additionalImageUrl,
      isPublished: product.isPublished,

      downloadLink: product.downloadLink || '',
      isDigitalProduct: product.isDigitalProduct || false,
      isTop: product.isTop || false,
      rawProduct: product,
    }
  }

  static parseExternalOrders(raw) {
    if (!raw?.data) return null
    if (!Array.isArray(raw?.data)) return null
    const appData = new AppData()
    appData.setContent('orders').setMetaData({
      page: raw.page,
      total: raw.total,
      orders: raw.data
        .map(order => {
          return {
            ...order,
            id: order.id,
            publicId: order.publicId,
            shippingMethod: order.shippingMethod,
            status: order.status,
            orderDate: order.orderDate,
            customerName: order.customerName,
            paymentMethod: order.paymentMethod,
            totalPrice: order.totalPrice,
            products: order.products,
          }
        })
        .reverse()
        .sort((o1, o2) => o2.orderDate - o1.orderDate),
    })
    return appData
  }

  static parseWithdrawalAccounts(rawAccounts) {
    if (!rawAccounts) return null
    if (!Array.isArray(rawAccounts)) return null
    const momoAccounts = []
    const bankAccounts = []
    rawAccounts.forEach(account => {
      const formatted = {
        image: `https://ui-avatars.com/api/?background=111429&color=fff&name=${
          account.fullName
        }&bold=true&font-size=0.55`,
        id: account.id,
        email: account.email,
        ownerId: account.ownerId,
        metadata: {
          ...account.metadata,
          type: account.metadata.type,
        },
        updateDate: account.updateDate,
        lastName: account.lastName,
        fullName: account.fullName,
        firstName: account.firstName,
        creationDate: account.creationDate,
        phoneNumber: account.phoneNumber,
        countryCode: account.countryCode,
        businessName: account.businessName,
      }
      if (account.metadata.type == 'bank') bankAccounts.push(formatted)
      else momoAccounts.push(formatted)
    })
    const appDataBank = new AppData()
    appDataBank.setContent('withdrawalAccountsBank').setMetaData({
      accounts: bankAccounts.sort(
        (a1, a2) => a2.creationDate - a1.creationDate,
      ),
    })
    const appDataMomo = new AppData()
    appDataMomo.setContent('withdrawalAccountsMomo').setMetaData({
      accounts: momoAccounts.sort(
        (a1, a2) => a2.creationDate - a1.creationDate,
      ),
    })
    return [appDataBank, appDataMomo]
  }

  static parseWithdrawals(raw) {
    if (!raw) return null
    if (!Array.isArray(raw.data)) return null
    const withdrawals = raw.data.map(withdrawal => {
      return {
        id: withdrawal.id,
        amount: withdrawal.amount,
        status: withdrawal.status,
        statusMessage: withdrawal.statusMessage,
        storeId: withdrawal.storeId,
        type: withdrawal.type,
        withdrawalAccount: withdrawal.withdrawalAccount,
        date: withdrawal.date,
        lastUpdateAt: withdrawal.lastUpdateAt,
      }
    })
    const appData = new AppData()
    appData.setContent('withdrawals').setMetaData({
      page: raw.page,
      total: raw.total,
      withdrawals: withdrawals.sort((w1, w2) => w2.date - w1.date),
    })
    return appData
  }

  static parseExternalCustomers(rawRiders) {
    if (!rawRiders) return null
    if (!Array.isArray(rawRiders)) return null
    const appData = new AppData()
    appData.setContent('customers').setMetaData({
      customers: rawRiders
        .map(customer => {
          return {
            ...customer,
            id: customer.id,
            image: customer.image,
            name: customer.name,
            email: customer.email,
            lastOrder: customer.lastOrder,
            totalOrdersCount: customer.totalOrdersCount,
            totalOrdersAmount: customer.totalOrdersAmount,
          }
        })
        .sort((c1, c2) => c2.lastOrder - c1.lastOrder),
    })
    return appData
  }

  static parseExternalRiders(rawRiders) {
    if (!rawRiders) return null
    if (!Array.isArray(rawRiders)) return null
    const appData = new AppData()
    appData.setContent('riders').setMetaData({
      riders: rawRiders
        .map(rider => {
          return {
            ...rider,
            id: rider.id,
            image: `https://ui-avatars.com/api/?background=111429&color=fff&name=${
              rider.email
            }&bold=true&font-size=0.55`,
            email: rider.email,
            createdAt: rider.createdAt,
            firstName: rider.firstName,
            lastName: rider.lastName,
            pendingDelivery: rider.pendingDelivery,
            position: rider.position,
            storeId: rider.storeId,
            totalDelivered: rider.totalDelivered,
          }
        })
        .sort((c1, c2) => c2.createdAt - c1.createdAt),
    })
    return appData
  }

  static formatRates(raw) {
    if (!raw) return null
    const appData = new AppData()
    const rates = {}
    Object.keys(raw).forEach(currency => {
      const currencyRates = raw[currency].body
      rates[currency] = currencyRates
    })
    appData.setContent('rates').setMetaData(rates)
    return appData
  }

  static parseExternalDeliveryLocations(raw) {
    if (!raw) return null
    if (!Array.isArray(raw)) return null
    const appData = new AppData()
    appData.setContent('deliveryLocations').setMetaData({
      locations: raw
        .map(location => {
          return {
            ...location,
            id: location.id,
            image: `https://ui-avatars.com/api/?background=111429&color=fff&name=${
              location.city
            }&bold=true&font-size=0.55`,
            city: location.city,
            latitude: location.latitude,
            longitude: location.longitude,
            countryName: location.countryName,
            countryCode: location.countryCode,
            state: location.state,
            deliveryCost: location.deliveryCost,
            currency: location.currency,
          }
        })
        .sort((c1, c2) => c2.createdAt - c1.createdAt),
    })
    return appData
  }

  static parseExternalPayments(raw) {
    if (!raw) return null
    if (!Array.isArray(raw?.data)) return null
    const appData = new AppData()
    appData.setContent('payments').setMetaData({
      page: raw.page,
      total: raw.total,
      payments: raw?.data
        .map(payment => {
          return {
            ...payment,
            id: payment.id,
            productName: payment.productName,
            description: payment.description,
            tags: payment.tags,
            colors: payment.colors,
            price: payment.price,
            quantity: payment.quantity,
            sku: payment.sku,
            rating: payment.rating,
            reviews: payment.reviews,
            image: payment.image,
            date: payment.date,
            customerName: payment.customerName,
            status: payment.status,
            statusMessage: payment.statusMessage,
          }
        })
        .reverse()
        .sort((c1, c2) => c2.date - c1.date),
    })
    return appData
  }

  static parseChargebacks(raw) {
    if (!raw) return null
    if (!Array.isArray(raw?.data)) return null
    const appData = new AppData()
    appData.setContent('payments').setMetaData({
      page: raw.page,
      total: raw.total,
      chargebacks: raw?.data
        .map(chargeback => {
          return {
            ...chargeback,
            id: chargeback.id,
            amount: chargeback.amount,
            appliedAt: chargeback.appliedAt,
            createdAt: chargeback.createdAt,
            currency: chargeback.currency,
            isApplied: chargeback.isApplied,
            transactionId: chargeback.transactionId,
            message: chargeback.message,
            productName: chargeback.transactionData.productName,
            description: chargeback.transactionData.description,
            tags: chargeback.transactionData.tags,
            colors: chargeback.transactionData.colors,
            price: chargeback.transactionData.price,
            quantity: chargeback.transactionData.quantity,
            sku: chargeback.transactionData.sku,
            rating: chargeback.transactionData.rating,
            reviews: chargeback.transactionData.reviews,
            image: chargeback.transactionData.image,
            date: chargeback.transactionData.date,
            customerName: chargeback.transactionData.customerName,
            status: chargeback.transactionData.status,
            statusMessage: chargeback.transactionData.statusMessage,
          }
        })
        .reverse()
        .sort((c1, c2) => c2.createdAt - c1.createdAt),
    })
    return appData
  }

  static parseStatsResponse(raw) {
    if (!raw) return null
    const appData = new AppData()
    appData.setContent('stats').setMetaData({
      customerStats: raw.customerStats.body?.data,
      customerStatsWeek: raw.customerStatsWeek.body?.data?.reverse(),
      customerStatsMonth: raw.customerStatsMonth.body?.data?.reverse(),
      customerStatsYear: raw.customerStatsYear.body?.data?.reverse(),
      orderStats: raw.orderStats.body?.data,
      orderStatsWeek: raw.orderStatsWeek.body?.data?.reverse(),
      orderStatsMonth: raw.orderStatsMonth.body?.data?.reverse(),
      orderStatsYear: raw.orderStatsYear.body?.data?.reverse(),
      paymentInitiatedStats: raw.paymentInitiatedStats.body?.data,
      paymentFailedStats: raw.paymentFailedStats.body?.data,
      paymentDoneStats: raw.paymentDoneStats.body?.data,
      paymentInitiatedStatsMonth:
        raw.paymentInitiatedStatsMonth.body?.data?.reverse(),
      paymentFailedStatsMonth:
        raw.paymentFailedStatsMonth.body?.data?.reverse(),
      paymentDoneStatsMonth: raw.paymentDoneStatsMonth.body?.data?.reverse(),
      paymentStats: raw.paymentDoneStats.body?.data,
      paymentStatsWeek: raw.paymentStatsWeek.body?.data?.reverse(),
      paymentStatsMonth: raw.paymentStatsMonth.body?.data?.reverse(),
      paymentStatsYear: raw.paymentStatsYear.body?.data?.reverse(),
    })
    return appData
  }

  static parseExternalKycData(raw, userId) {
    const appData = new AppData()
    const isFilled = !!(
      raw?.validationStatus &&
      (raw?.validationStatus !== 'notFilled' ||
        raw?.validationStatus == 'filled')
    )
    const isValidated = raw?.validationStatus == 'validated'
    const isPending = raw?.validationStatus == 'pending'
    const isRejected = raw?.validationStatus == 'rejected'
    appData.setContent('kycData').setMetaData({
      ...(raw || {}),
      data: raw?.data || {},
      rejectionReason: raw.rejectionReason || '',
      url: 'https://kyc.marketplace.ecoxurf.com?id=' + userId,
      isFilled,
      isValidated,
      isPending,
      isRejected,
    })
    return appData
  }

  static buildAppDataEntity(rawData) {
    if (!rawData) return null
    const appData = new AppData()
    appData.setContent(rawData.content).setMetaData(rawData.metaData)
    return appData
  }
}

function formatIsLockedData(raw = {}) {
  const metaDataKeys = ['isLocked']
  return formatMetaData(raw, metaDataKeys)
}

function formatMetaData(source, keys) {
  const metaData = {}
  keys.forEach(key => {
    metaData[key] = source[key]
  })
  return metaData
}

function formatPubsMetaData(rawPubs = []) {
  if (!Array.isArray(rawPubs)) return { pubs: [] }
  return {
    pubs: rawPubs.map(pub => {
      return {
        title: pub.title,
        description: pub.description,
        pictureUrl: pub.pictureUrl,
        actionTitle: pub.actionTitle,
        action: pub.action,
        isCouponsPub: pub.isCouponsPub,
        date: pub.date,
      }
    }),
  }
}

function formatCouponsMetaData(rawCoupons = []) {
  if (!Array.isArray(rawCoupons)) return { coupons: [] }
  return {
    coupons: rawCoupons.map(coupon => {
      return {
        pictureUrl: coupon.pictureUrl,
        isVip: coupon.isVip,
        code: coupon.code || '',
        isValidated: coupon.isValidated || false,
        bookmaker: coupon.bookmaker || '',
      }
    }),
  }
}

// function formatTopMatchesMetaData(rawTopMatches = []) {
//   if (!Array.isArray(rawTopMatches)) return { pubs: [] };
//   return {
//     topMatches: rawTopMatches.map((match, i) => {
//       let statusDisplay = "Non démaré";
//       if (match.matchStatus == "finished") statusDisplay = "Terminé";
//       if (match.matchStatus == "starting") statusDisplay = "En cours";
//       if (match.matchStatus == "live") statusDisplay = "En cours";
//       return {
//         id: i,
//         startTimestamp: match.startTimestamp,
//         day: match.day,
//         month: match.month,
//         year: match.year,
//         liveDurationMin: match.liveDurationMin,
//         dateDisplay: Commons.timestampToDate(
//           match.startTimestamp,
//           "DD MMM YYYY HH:mm"
//         ),
//         statusDisplay,
//         matchStatus: match.matchStatus,
//         startHour: match.startHour,
//         startMin: match.startMin,
//         matchId: match.matchId,
//         competitionName: match.competitionName,
//         matchPageUrl: match.matchPageUrl,
//         team1Name: match.team1Name,
//         team2Name: match.team2Name,
//         team1Score: match.team1Score,
//         team2Score: match.team2Score,
//         team1Picture: match.team1Picture,
//         team2Picture: match.team2Picture,
//       };
//     }),
//   };
// }

function formatTopMatchesMetaData(rawTopMatches = []) {
  if (!Array.isArray(rawTopMatches)) return { topMatches: [] }
  console.log(rawTopMatches.length)
  rawTopMatches = rawTopMatches.splice(0, 200)
  return {
    isSorted: true,
    updatedAt: Date.now(),
    topMatches: rawTopMatches
      .map((match, i) => {
        const matchStatus = match.isLive ? 'live' : 'notStarted'
        let statusDisplay = 'Non démaré'
        if (matchStatus == 'finished') statusDisplay = 'Terminé'
        if (matchStatus == 'starting') statusDisplay = 'En cours'
        if (matchStatus == 'live') statusDisplay = 'En cours'
        const date = new Date(match.date_start)
        let durationMin = (Date.now() - date.getTime()) / 1000 / 60
        durationMin = parseInt(durationMin)
        let usedMarkey = {}
        if (match.markets)
          usedMarkey = {
            win1: match.markets.win1,
            win2: match.markets.win2,
            winX: match.markets.winX,
            win12: match.markets.win12,
            win1X: match.markets.win1X,
            winX2: match.markets.winX2,
          }

        return {
          id: i,
          isLive: match.isLive,
          startTimestamp: date.getTime(),
          day: date.getDay(),
          month: date.getMonth(),
          year: date.getFullYear(),
          liveDurationMin: durationMin,
          dateDisplay: Commons.timestampToDate(
            date.getTime(),
            'DD MMM YYYY HH:mm',
          ),
          statusDisplay,
          matchStatus: matchStatus,
          startHour: date.getHours(),
          startMin: date.getMinutes(),
          matchId: match.id,
          competitionName: match.title,
          matchPageUrl: '',
          matchName: getMatchName(match.team1, match.team2),
          team1Name: match.team1,
          team2Name: match.team2,
          team1Score: match.score1,
          team2Score: match.score2,
          team1Picture: '',
          team2Picture: '',
          team1Picture: '/images/football.svg',
          team2Picture: '/images/football.svg',
          // ...match,
          markets: usedMarkey,
        }
      })
      .sort((match1, match2) => {
        if (match1.startTimestamp > match2.startTimestamp) return 1
        if (match1.startTimestamp < match2.startTimestamp) return -1
        return 0
      }),
  }
}

function formatMatchFiltersMetaData(upcoming = [], live = []) {
  if (!Array.isArray(upcoming) || !Array.isArray(live)) return { filters: [] }
  const filtersIds = {}
  return {
    updatedAt: Date.now(),
    filters: [...live, ...upcoming]
      .map((filter, i) => {
        if (filtersIds[filter.league_id]) return null
        if (/[Государственный'||"{?;]/i.test(filter.league || filter.title))
          return null
        filtersIds[filter.league_id] = true
        return {
          id: filter.league_id,
          name: filter.league || filter.title,
          title: filter.title,
          ...filter,
        }
      })
      .filter(filter => !!filter),
  }
}

function getMatchName(team1, team2) {
  let max = 15
  let team1Short = team1.slice(0, max)
  let team2Short = team2.slice(0, max)
  if (team1.length > max) team1Short = team1.slice(0, max - 3) + '...'
  if (team2.length > max) team2Short = team2.slice(0, max - 3) + '...'
  return team1Short + ' VS ' + team2Short
}

function detectHostingProvider(dnsString) {
  const providers = [
    {
      id: 'namecheap',
      name: 'Namecheap',
      patterns: [
        'namecheap',
        'namecheaphosting.com',
        'trs-dns.com',
        'tucows.com',
      ],
    },
    { id: 'ovh', name: 'OVH', patterns: ['ovh'] },
    { id: 'godaddy', name: 'GoDaddy', patterns: ['godaddy'] },
    { id: 'bluehost', name: 'Bluehost', patterns: ['bluehost'] },
    { id: 'hostgator', name: 'HostGator', patterns: ['hostgator'] },
    { id: 'siteground', name: 'SiteGround', patterns: ['siteground'] },
    { id: 'cloudflare', name: 'Cloudflare', patterns: ['cloudflare'] },
    { id: 'ionos', name: 'IONOS', patterns: ['ionos', '1and1'] },
    { id: 'hostinger', name: 'Hostinger', patterns: ['hostinger'] },
    { id: 'dreamhost', name: 'DreamHost', patterns: ['dreamhost'] },
    { id: 'a2hosting', name: 'A2 Hosting', patterns: ['a2hosting'] },
    { id: 'inmotion', name: 'InMotion Hosting', patterns: ['inmotionhosting'] },
    { id: 'greengeeks', name: 'GreenGeeks', patterns: ['greengeeks'] },
    { id: 'liquidweb', name: 'Liquid Web', patterns: ['liquidweb'] },
    { id: 'wpengine', name: 'WP Engine', patterns: ['wpengine'] },
  ]

  for (const provider of providers) {
    if (
      provider.patterns.some(pattern =>
        dnsString.toLowerCase().includes(pattern),
      )
    ) {
      return { id: provider.id, name: provider.name }
    }
  }

  return { id: 'unknown', name: 'Fournisseur inconnu' }
}

export { Formatter }
